export default __webpack_public_path__ + "static/AppCV2-bc4c307b2be91abab50d6e80220829b8.png";